import { styled } from '@mui/material';

const VariableChipStylesWrapper = styled('div')({
  width: '9rem',
  height: '1.5rem',
  display: 'flex',
  flexDirection: 'row-reverse',
});

export default VariableChipStylesWrapper;
